var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FooterSpacer'),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v(_vm._s(_vm.$t('cartRecover.title')))]),(_vm.errorText)?_c('p',{staticClass:"bg-danger text-white"},[_vm._v(_vm._s(_vm.errorText))]):_vm._e()])])]),_c('FooterSpacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }